import { NAVIGATION } from '../../containers/App/constants';
import { createStay22Url } from '../../utils/stay22';

/**
 * @description Builds a Stay22 accommodation URL based on the current pathname.
 * @param {string} pathname - The current URL pathname.
 * @returns {string} The generated Stay22 accommodation URL.
 */
export const buildAccommodationUrl = (pathname: string) => {
  const isSearchPage = pathname.startsWith(NAVIGATION.SEARCH);
  const parts = pathname.split('/');
  const destination = isSearchPage && parts.length >= 4 ? parts[3] : undefined;

  return createStay22Url({
    campaign: isSearchPage ? 'navbar_search' : 'navbar',
    address: destination,
  });
};
